import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        tax_identifier_short: "ID fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
        ornz: "ORNZ",
        ogrn: "OGRN",
        research_email: "E-mail de recherche",
        lead_priority: "Priorité commerciale",
        lead_priority_rank: "Priorité commerciale",
        lead_score: "Score du prospect",
        decision_maker: "Décideur",
        decision_maker_role: "Rôle du décideur",
        decision_maker_profile_url: "Profil du décideur",
        website_status: "État du site web",
        digital_maturity_score: "Maturité numérique",
        specializations: "Spécialisations",
        social_profile_count: "Profils sociaux",
        has_vacancy_signal: "Signal de recrutement",
        vacancy_freshness: "Actualité des postes",
        has_cases_clients: "Cas ou clients publiés",
        personalized_reason: "Motif commercial personnalisé",
        research_checked_at: "Date de recherche",
        research_source_urls: "Sources de recherche",
        revenue_2025_thousand_rub: "CA 2025, milliers de RUB",
        marketing_consent_status: "Statut du consentement publicitaire",
        marketing_consent_channel: "Canal du consentement",
        marketing_consent_granted_at: "Date et heure du consentement",
        marketing_consent_evidence_url: "Preuve du consentement",
        do_not_contact: "Ne pas contacter",
        sro_membership_status: "Statut d'adhésion à la SRO",
        sro_membership_ended_at: "Date de fin d'adhésion",
        sro_membership_end_reason: "Motif de fin d'adhésion",
        sro_membership_checked_at: "Date de vérification de l'adhésion",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
        sales_intelligence: "Données commerciales",
        contact_permission: "Autorisation de contact",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      auditors_count_value:
        "%{smart_count} auditeur |||| %{smart_count} auditeurs",
      priority: {
        high: "Haute",
        medium: "Moyenne",
        low: "Basse",
      },
      sro_membership: {
        active: "Adhésion active",
        ceased: "Adhésion terminée",
      },
      consent_status: {
        unknown: "Consentement non confirmé",
        requested: "Consentement demandé",
        granted: "Consentement confirmé",
        revoked: "Consentement retiré",
        stop_list: "Liste d'exclusion",
      },
      consent_channel: {
        phone: "Téléphone",
        email: "E-mail",
        messenger: "Messagerie",
        form: "Formulaire du site",
        event: "Événement",
        referral: "Recommandation",
        contract: "Contrat",
        not_set: "Canal non défini",
      },
      digital_maturity: {
        high: "Haute : 8–10",
        medium: "Moyenne : 5–7",
        low: "Basse : 0–4",
      },
      sales: {
        score: "Score %{score}",
        digital_maturity: "Maturité numérique %{score}/10",
        social_profiles:
          "%{smart_count} profil social |||| %{smart_count} profils sociaux",
        has_cases_clients: "Cas/clients publiés",
        has_vacancy_signal: "Signal de recrutement",
        more_specializations: "+%{smart_count}",
        research_checked_at: "Recherche vérifiée : %{date}",
        sources: "%{smart_count} source |||| %{smart_count} sources",
        public_contact_notice:
          "Une coordonnée publique ne constitue pas un consentement publicitaire.",
        sro_membership_ceased:
          "Exclue de la file commerciale active car l'adhésion à la SRO a pris fin.",
      },
      sizes: {
        one_to_three_active_auditors: "1-3",
        four_to_ten_active_auditors: "4-10",
        eleven_to_twenty_five_active_auditors: "11-25",
        twenty_six_to_fifty_active_auditors: "26-50",
        more_than_fifty_active_auditors: "50+",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
      filters: {
        auditors_count: "Nombre d'auditeurs",
        all_cities: "Toutes les villes",
        all_managers: "Tous les responsables",
        all_regions: "Toutes les régions",
        city_region: "Ville/région",
        no_regions: "Aucune région trouvée",
        only_mine: "Seulement les entreprises que je gère",
        search: "Rechercher des entreprises",
        search_city: "Rechercher une ville",
        search_region: "Rechercher une région",
        sales_priority: "Priorité commerciale",
        specialization: "Spécialisation",
        all_specializations: "Toutes les spécialisations",
        sales_signals: "Signaux commerciaux",
        with_social_profiles: "Profils sociaux disponibles",
        with_cases_clients: "Cas/clients publiés",
        with_vacancy_signal: "Signal de recrutement",
        with_reachable_website: "Site accessible",
        digital_maturity: "Maturité numérique",
        contact_permission: "Autorisation de contact",
        sro_membership_status: "Statut d'adhésion à la SRO",
      },
      import: {
        title: "Importer des entreprises",
        button: "Importer un CSV",
        complete:
          "Import des entreprises terminé. %{importCount} lignes traitées, %{errorCount} erreurs.",
        progress:
          "Importées %{importCount} / %{rowCount} entreprises, %{errorCount} erreurs.",
        error: "Échec de l'import : vérifiez que le fichier CSV est valide.",
        remaining_time: "Temps restant estimé :",
        running: "Import en cours, ne fermez pas cet onglet.",
        sample_download: "Télécharger un exemple CSV",
        sample_hint:
          "Utilisez l'exemple pour le format des colonnes. Les entreprises existantes sont mises à jour par identifiant fiscal ou nom exact ; les nouvelles sont créées.",
        stop: "Arrêter l'import",
        csv_file: "Fichier CSV",
      },
    },
    audit_research_directory: {
      name: "Entrée de recherche |||| Annuaire de recherche",
      nav: "Recherche",
      title: "Auditeurs, experts et communautés professionnelles",
      company_section: "Auditeurs et canaux publics",
      company_social:
        "%{smart_count} canal public |||| %{smart_count} canaux publics",
      company_auditors: "%{smart_count} auditeur |||| %{smart_count} auditeurs",
      ceased_company_people_notice:
        "Les personnes sont conservées comme données historiques ; leur emploi actuel n'est pas confirmé après la fin de l'adhésion de l'entreprise à la SRO.",
      view_company_entries:
        "Voir %{smart_count} entrée |||| Voir les %{smart_count} entrées",
      open: "Ouvrir le profil",
      source: "Preuve",
      fields: {
        record_kind: "Catégorie",
        name: "Personne ou canal",
        company_name: "Entreprise",
        company_ornz: "ORNZ de l’entreprise",
        role_or_audience: "Rôle ou audience",
        person_ornz: "ORNZ de la personne",
        certificate_number: "Certificat",
        employment_type: "Emploi",
        platform: "Plateforme",
        contact_url: "Profil public",
        source_url: "Source de preuve",
        source_type: "Type de source",
        confidence: "Fiabilité",
        checked_at: "Vérifié le",
      },
      kinds: {
        manager: "Dirigeant",
        auditor: "Auditeur",
        expert: "Expert",
        company_social: "Canal d’entreprise",
        expert_social: "Canal d’expert",
        community: "Communauté",
      },
      confidence: {
        high: "Fiabilité élevée",
        medium: "Fiabilité moyenne",
        low: "Fiabilité faible",
      },
      employment: {
        primary: "Emploi principal",
        part_time: "Emploi à temps partiel",
      },
    },
    company_interactions: {
      name: "Interaction |||| Interactions",
      title: "Interactions",
      subtitle:
        "Appels, présentations, démos, contrats, factures, support et ventes additionnelles.",
      tab: "Interactions",
      empty: "Aucune interaction pour le moment.",
      load_error: "Impossible de charger les interactions.",
      created: "Interaction ajoutée",
      action: {
        add: "Ajouter",
        add_report: "Ajouter un rapport",
        save_report: "Enregistrer le rapport",
      },
      dialog: {
        create_for: "Ajouter une interaction : %{name}",
        report_for: "Rapport entreprise",
      },
      overview: {
        stage: "Étape",
        latest: "Dernier contact",
        next_step: "Prochaine étape",
        status: "Statut",
        no_deal: "Aucune affaire",
        no_interactions: "Aucune interaction",
        no_next_step: "Aucune prochaine étape",
        overdue: "En retard",
        on_track: "En cours",
        has_next_step: "Prochaine action planifiée",
      },
      linked: {
        contact: "Contact : %{name}",
        deal: "Affaire : %{name}",
      },
      fields: {
        company_id: "Entreprise",
        contact_id: "Contact",
        deal_id: "Affaire",
        type: "Type",
        interaction_date: "Date",
        summary: "Ce qui s'est passé",
        result: "Résultat",
        next_step: "Prochaine étape",
        next_step_date: "Date de la prochaine étape",
        sales_id: "Responsable",
      },
      types: {
        call: "Appel",
        message: "Message",
        email: "E-mail",
        meeting: "Réunion",
        presentation_sent: "Présentation envoyée",
        demo_scheduled: "Démo planifiée",
        demo_done: "Démo réalisée",
        contract_preparation: "Préparation du contrat",
        invoice_sent: "Facture envoyée",
        payment_received: "Paiement reçu",
        implementation: "Déploiement",
        support: "Support",
        feature_presentation: "Présentation de nouvelle fonctionnalité",
        upsell: "Vente additionnelle",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
        button: "Importer un fichier CSV",
        complete:
          "Import des contacts terminé. %{importCount} contacts importés, %{errorCount} erreurs",
        progress:
          "%{importCount} / %{rowCount} contacts importés, avec %{errorCount} erreurs.",
        error:
          "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
        imported: "Importé",
        remaining_time: "Temps restant estimé :",
        running: "L'import est en cours, merci de ne pas fermer cet onglet.",
        sample_download: "Télécharger un exemple CSV",
        sample_hint:
          "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
        stop: "Arrêter l'importation",
        csv_file: "Fichier CSV",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        noop: "Les contacts sélectionnés ont déjà cette étiquette",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    deals: {
      name: "Affaire |||| Affaires",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Catégorie",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
      },
      field_categories: {
        misc: "Divers",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
      editor: {
        slash_hint: "Blocs",
        commands: {
          paragraph: "Texte",
          heading_1: "Titre 1",
          heading_2: "Titre 2",
          bullet_list: "Liste à puces",
          ordered_list: "Liste numérotée",
          quote: "Citation",
          code: "Bloc de code",
          divider: "Séparateur",
        },
        command_descriptions: {
          paragraph: "Paragraphe simple",
          heading_1: "Grand titre de section",
          heading_2: "Titre moyen de section",
          bullet_list: "Créer une liste simple",
          ordered_list: "Créer une liste numérotée",
          quote: "Mettre en avant un fragment important",
          code: "Bloc monospace",
          divider: "Séparer les sections",
        },
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        administrator: "Admin",
        disabled: "Désactivé",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success:
          "Utilisateur créé. Ils recevront prochainement un email pour définir leur mot de passe.",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Atomic CRM",
    },
    common: {
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      stepper: {
        install: "Installer Atomic CRM",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    header: {
      import_data: "Importer des données",
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer des données",
    },
    settings: {
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des affaires : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
    },
    mobile_navigation: {
      more: "Plus",
    },
    knowledge_base: {
      articles_count: "articles",
      back_to_index: "Base de connaissances",
      description:
        "Documents produit et business pour Doka : stratégie, planification, analyse concurrentielle et méthodologie interne.",
      open_article: "Ouvrir",
      section_label: "Documents internes",
      title: "Base de connaissances",
      updated: "Mis à jour",
    },
    mail: {
      tab: "E-mail",
      account: {
        title: "E-mail IMAP/SMTP",
        description:
          "Connectez une boîte aux lettres via IMAP et SMTP pour recevoir et envoyer des e-mails depuis le CRM.",
        connect: "Connecter l’e-mail",
        connected: "E-mail connecté",
        disconnected: "Boîte aux lettres déconnectée",
      },
      sync: {
        complete: "Synchronisation terminée : %{count} nouveaux messages",
      },
    },
    profile: {
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Atomic CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
        tokens: {
          title: "Jetons d’accès personnels",
          description:
            "Créez un jeton révocable pour un client MCP. Il dispose des mêmes autorisations CRM que votre compte.",
          name: "Nom du jeton",
          name_placeholder: "Par exemple, Codex sur Mac",
          expires: "Expiration",
          days: "%{days} jours",
          create: "Créer",
          created: "Jeton MCP créé",
          copy_now: "Copiez ce jeton maintenant",
          shown_once:
            "Il ne sera plus affiché après la fermeture de ce message.",
          empty: "Vous n’avez pas encore de jeton MCP personnel.",
          load_error: "Impossible de charger les jetons MCP.",
          expires_at: "Expire le %{date}",
          last_used: "Dernière utilisation le %{date}",
          revoke: "Révoquer le jeton",
          revoke_confirm:
            "Révoquer le jeton « %{name} » ? Cette action est irréversible.",
          revoked: "Jeton MCP révoqué",
          status: {
            active: "Actif",
            expired: "Expiré",
            revoked: "Révoqué",
          },
        },
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
  },
} satisfies CrmMessages;
